export const SPECIAL_OBJECT_VOID = 'special-object-void';

export type ReviewType = 'book' | 'teacher' | 'course' | 'center';
